import { type CMSData } from '@/features/cms/components/CMS/types'
import { isPageLayoutWithSeoMetadata } from '@/features/cms/components/CMS/utils/typeGuards'

export const getLocalSchemaMetadata = (cmsData?: CMSData) => {
  let city, state, zip

  if (isPageLayoutWithSeoMetadata(cmsData)) {
    const seoMetadata = cmsData.content.data.seo_metadata
    city = seoMetadata?.data.city.split(',')[0] // In some instances the city is stored as "City, State", so we take only the city part
    state = seoMetadata?.data.state
    zip = seoMetadata?.data.zip
  }

  return {
    city,
    state,
    zip,
  }
}
